// eslint-disable-next-line
// @ts-nocheck
import Accordion from '../../components/accordion';
import { itemType } from 'metadata';
import viewAsAccordionCSS from '../../../styles/less/aras/tocEditorAccordion.less';
import getResource from '../../core/resources';
import { wire } from 'hyperhtml';

const viewAsAccordionStylesheet = new CSSStyleSheet();
viewAsAccordionStylesheet.replaceSync(viewAsAccordionCSS);

class ViewAsAccordion extends Accordion {
	constructor() {
		super();

		this.reversed = true;
		this.collapsed = true;
	}

	created() {
		super.created();

		this.shadowRoot.adoptedStyleSheets = [
			...this.shadowRoot.adoptedStyleSheets,
			viewAsAccordionStylesheet
		];
		this.classList.add('toc-editor__view-as-accordion');
	}

	connectedCallback() {
		super.connectedCallback();

		const header = this.shadowRoot.querySelector('.aras-accordion__header');
		header.addEventListener('click', () => {
			this.collapsed = !this.collapsed;
		});
	}
}

const name = 'aras-accordion-view-as';
if (!customElements.get(name)) {
	ViewAsAccordion.define(name);
}

export default async (layout, viewAsChangeHandler) => {
	const state = layout.state || {};
	const { viewAs } = state;
	const formContext = wire(layout, ':view-as-form');
	const formChangeHandler = (e) => {
		const { detail } = e;
		if (!detail) {
			return;
		}

		const { itemId: value, label } = detail.newValue;
		if (!value) {
			if (detail.propName === 'identity') {
				layout.actions.resetViewAs();
			} else {
				layout.actions.setViewAs({
					[detail.propName]: null
				});
				viewAsChangeHandler();
			}
			return;
		}

		const { viewAs: oldViewAs } = state;
		layout.actions.setViewAs({
			[detail.propName]: { value, label }
		});

		const hasViewAsChanged = value !== oldViewAs?.[detail.propName]?.value;
		if (hasViewAsChanged) {
			viewAsChangeHandler();
		}
	};
	const form = formContext`
		<aras-form-view
			class="toc-editor__view-as-form"
			onchange=${formChangeHandler}
		/>`;
	const identityItemTypeName = 'Identity';
	const languageItemTypeName = 'Language';
	const { getItemType } = itemType;
	const [identityItemType, languageItemType] = await Promise.all([
		getItemType(identityItemTypeName),
		getItemType(languageItemTypeName)
	]);
	const identityDisabled =
		state.changes && Object.keys(state.changes).length > 0;
	const availableLanguages = viewAs?.prevLanguages ?? state.languages;
	const languageDisabled =
		!viewAs || identityDisabled || availableLanguages.length === 1;
	form.metadata = {
		identity: {
			type: 'item',
			itemTypeName: identityItemTypeName,
			disabled: identityDisabled,
			placeholder: identityItemType.label,
			icon: identityItemType.open_icon,
			validation: true
		},
		language: {
			type: 'item',
			itemTypeName: languageItemTypeName,
			disabled: languageDisabled,
			placeholder: languageItemType.label,
			icon: languageItemType.open_icon,
			validation: true
		}
	};
	form.order = Object.keys(form.metadata);
	form.data = {
		identity: viewAs?.identity,
		language: viewAs?.language
	};
	form.resetState();
	form.render();

	// header color should be yellow when filter is active and it's impossible to do with css-class
	// because hyperHTML replaces basic component classes in this case.
	// so used attribute "filtered" (see styles in tocEditorAccordion.less)
	const filterActive = !!viewAs;
	const filters = [];
	if (viewAs?.identity) {
		filters.push(viewAs.identity.label);
	}
	if (viewAs?.language) {
		filters.push(viewAs.language.label);
	}
	const filterLabel = filters.join(', ');

	const headerLabel = viewAs
		? getResource('toc_editor.view_as_something', filterLabel)
		: getResource('toc_editor.view_as');
	const clearLabel = getResource('toc_editor.clear_view_as');
	const clearDisabledClass = viewAs ? '' : 'aras-link_a-disabled';
	const clearHandler = (e) => {
		e.stopPropagation();
		layout.actions.resetViewAs();
	};
	const accordionContext = wire(layout, ':view-as-accordion');

	return accordionContext`
			<aras-accordion-view-as ?filtered=${filterActive}>
				<div class="toc-editor__view-as-header" slot="header">
					<span class="toc-editor__view-as-title">${headerLabel}</span>
					<span 
						class="toc-editor__view-as-clear-link aras-link aras-link_a ${clearDisabledClass}"
						onclick=${clearHandler}
					>
						${clearLabel}
					</span>
				</div>
				${form}
			</aras-accordion-view-as>
		`;
};
